import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Nomenclature item and group response body common fields */
export interface NomenclatureBaseFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion date and time. The item/group will be permanently deleted six months after this date. */
  deleted?: Date;
  /** The user who created this item/group */
  createdBy?: UserFindInterface;
  /** Item/group display name */
  name: string;
}

/** Nomenclature item and group response body common fields - DTO schema */
export const NomenclatureBaseFindDto = SerdeDtoClass.create<NomenclatureBaseFindInterface>(CatalogDtosKeysEnum.NOMENCLATURE_BASE_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  createdBy: {
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
});
